import { HTTP_BAD_REQUEST_STATUS } from '@vk-hr-tek/core/http';
import { Box } from '@vk-hr-tek/ui/Box';

import { PageError, PageFallback } from '../layout';
import { DegradationBanner } from '../layout/DegradationBanner';

import { useAuthType, useIsAuthDegradationBannerAllowed } from './hooks';
import { AUTH_CONTENT_MAX_WIDTH } from './constants';
import {
  GeneralAuth,
  VKAuth,
  AliAuth,
  CandidateAuth,
  OAuth2,
  OpenId,
  Esia,
} from './pages';

export const Auth = () => {
  const { status, authType, error } = useAuthType();
  const isDegradationBannerAllowed = useIsAuthDegradationBannerAllowed();

  if (status === 'idle' || status === 'loading') return <PageFallback />;

  if (status === 'failed')
    return (
      <>
        {isDegradationBannerAllowed && (
          <Box
            width="100%"
            maxWidth={AUTH_CONTENT_MAX_WIDTH}
            mx="auto"
            px={{ xs: '16', md: '0' }}
          >
            <DegradationBanner embedded mt={{ xs: '32', md: '72' }} />
          </Box>
        )}
        <PageError
          status={error?.status || HTTP_BAD_REQUEST_STATUS}
          errorMessage={error?.message}
        />
      </>
    );

  switch (authType) {
    case 'candidate':
      return <CandidateAuth />;

    case 'vk':
    case 'internalVpnOff':
      return <VKAuth />;

    case 'pass':
      return <AliAuth />;

    case 'openid_jwt':
      return <OpenId />;

    case 'oauth2':
    case 'openid':
      return <OAuth2 />;

    case 'esia':
      return <Esia />;

    default:
      return <GeneralAuth />;
  }
};
